import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { DEFAULTS } from "../data/defaults";

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULTS);
  const [settings, setSettings] = useState({ events_enabled: false, news_enabled: false });
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const [c, s] = await Promise.all([api.get("/content"), api.get("/settings")]);
      setContent({ ...DEFAULTS, ...c.data });
      setSettings(s.data);
    } catch (e) {
      console.error("content load failed", e);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <ContentContext.Provider value={{ content, settings, setContent, setSettings, reload: load, loaded }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
